import { faCheck, faLightbulb, faMoneyBill, faPaperclip, faTrash } from '@fortawesome/pro-solid-svg-icons';
import { HateoasResource } from '@lagoshny/ngx-hateoas-client';
import { TranslateService } from '@ngx-translate/core';
import { Note } from 'src/app/rgs/components/objects/object-item/object-inspection/models/note.model';
import { Status } from 'src/app/shared/models/status.model';
import { CompanyOwned } from '../company/company-models.model';
import { EmbeddedBaseObject } from '../embedded-base-object.model';
import { RgsObject } from '../objects/rgs-object.model';
import { PricebookCode } from '../pricebook/pricebook-code.model';

export interface ScenarioSimplified {
  id: string;
  naam: string;
  rgsObjectId: string;
  elementen: ElementSimplified[];
}

export enum ScenarioStatus {
  BUDGET = 'budget',
  CONCEPT = 'concept',
  DEFINITIVE = 'definitief',
  ASSIGNMENT = 'opdracht',
  ARCHIVE = 'archief',
}

export enum LayerType {
  DIRECT = 'DIRECT',
  INDIRECT = 'INDIRECT',
  STATIC = 'STATIC',
  SUBTOTAL = 'SUBTOTAL',
  ROOT = 'ROOT'
}

export const scenarioStatuses = (translateService?: TranslateService) =>
  [
    {
      value: ScenarioStatus.BUDGET,
      label: translateService?.instant(`statuses.${ScenarioStatus.BUDGET}`),
      icon: faMoneyBill,
      severity: 'budget-status',
    },
    {
      value: ScenarioStatus.CONCEPT,
      label: translateService?.instant(`statuses.${ScenarioStatus.CONCEPT}`),
      icon: faLightbulb,
      severity: 'concept-status',
    },
    {
      value: ScenarioStatus.DEFINITIVE,
      label: translateService?.instant(`statuses.${ScenarioStatus.DEFINITIVE}`),
      icon: faCheck,
      severity: 'definitive-status',
    },
    {
      value: ScenarioStatus.ASSIGNMENT,
      label: translateService?.instant(`statuses.${ScenarioStatus.ASSIGNMENT}`),
      icon: faPaperclip,
      severity: 'assignment-status',
    },
    {
      value: ScenarioStatus.ARCHIVE,
      label: translateService?.instant(`statuses.${ScenarioStatus.ARCHIVE}`),
      icon: faTrash,
      severity: 'archive-status',
    },
  ] as Status<ScenarioStatus>[];

@HateoasResource('scenario')
export class Scenario extends CompanyOwned {
  public naam!: string;
  public nummer!: number;
  public rgsObjectId!: string;
  public periode!: number;
  public splitsingtype!: string;
  public startjaar!: number;
  public status!: ScenarioStatus;
  public toelichting!: string;
  public eindjaar!: number;
  public lagen!: Array<Laag>;
  public elementen!: Array<Element>;
  public prijzenboek!: string;
  public locked!: boolean;
  public label!: string;

  public object?: RgsObject;

  //RESOLVED
  public pricebookCode!: PricebookCode;
  public notes?: Note[];

  //SCENARIO COMPARE
  public total?: number;
  public totalPerVHE?: number;
  public totalIndexed?: number;
  public totalNcw?: number;
}

export class Laag extends EmbeddedBaseObject {
  public duplicaten!: number;
  public naam!: string;
  public vanlaag!: string;
  public index: number[] = [];
  public layerType!: LayerType;
  //front only
  public dataPath?: string[];
  public faLayerGroup?: boolean;
  public isLayer?: boolean;
  public icon?: string;
  public rowClass?: string;
  public staticRow?: boolean;
  public noShowButtons?: boolean;
  public showElementButton?: boolean;
  public staticIndex!: number;
  public showSubtotal!: boolean;
  public editableRow!: boolean;
  public isSubtotal!: boolean;
}

export interface ElementSimplified {
  hvh: number;
  index: number;
  maatregelen: MaatregelSimplified[];
}

export class Element extends EmbeddedBaseObject {
  public code: string | undefined;
  public eenheid: string | undefined;
  public groep: string | undefined;
  public hvh!: number;
  public index: number[] = [];
  public laag!: string;
  public naam!: string;
  public variant!: Variant;
  public maatregelen!: Maatregel[];
  public staticElement!: boolean;
  public nlsfb?: string;

  //front only
  public dataPath?: string[];
}

export interface MaatregelSimplified {
  hvh: number;
  prijs: number;
  schemas: Schema[];
}

export class Maatregel extends EmbeddedBaseObject {
  public btw!: string;
  public code!: string;
  public eenheid!: string;
  public hvh!: number;
  public index: number[] = [];
  public info1!: string;
  public info2!: string;
  public naam!: string;
  public prijs!: number;
  public vasteprijs!: boolean;
  public schemas!: Array<Schema>;
  public mki!: number;
  public co2!: number;
  public tijd!: number;
  //front only
  public dataPath?: string[];
}

export class Schema {
  public aantal!: number;
  public jaar!: number;
}

export class Variant {
  public variant!: string;
}
